import axios from 'axios';

class AdivitosDataService {
  getAll() {
    return axios.get(`/api/aditivos`);
  }

  getSimple() {
    return axios.get(`/api/aditivos/search`);
  }

  get(id) {
    return axios.get(`/api/aditivos/${id}`);
  }

  getEquivalencias(id) {
    return axios.get(`/api/aditivos/${id}/equivalencias`);
  }

  create(data) {
    return axios.post(`/api/aditivos`, data);
  }

  update(id, data) {
    return axios.put(`/api/aditivos/${id}`, data);
  }
  
  updateEquivalencias(id, data) {
    return axios.put(`/api/aditivos/${id}/equivalencias`, data);
  }

  updateUtilidades(id, data) {
    return axios.put(`/api/aditivos/${id}/utilidades`, data);
  }

  delete(id) {
    return axios.delete(`/api/aditivos/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/aditivos`);
  }
}

export default new AdivitosDataService();